$(document).ready(function () { 
	// Filters slide down
	$(".JSfilters-slide-toggle").click(function(){
		$(this).next(".JSfilters-slide-toggle-content").slideToggle('fast');
	});

	if ($('.selected-filters li').length) {
		$('.JShidden-if-no-filters').show();
	}

	// PAGINATION AND FILTERS
	// if($('.pagination').length) {
	// 	var location_search = window.location.search.split('?').pop(); //remove ? from location.search

	// 	$('.pagination > li > a').each(function(){
	// 		var link_href = $(this).attr('href');
	// 		if(!link_href.includes(location_search)) {

	// 			new URL(location.href).searchParams.get('page')
	// 			const params = new URL(location.href).searchParams;
	// 			const page_num = params.get('page'); //example page=3, this return 3

	// 			location_search = location_search.split('page='+page_num+'&').pop(); //example remove page=3& from search
	// 			$(this).attr('href', link_href + '&' +  location_search);
	// 			}
	// 	});
	// } 

	// GENERIC CAR TITLE
	$('.generic_car li').each(function(i, li) {
		if ($(li).text().trim().length > 20) {
			$(li).attr('title', $(li).text().trim());
		} 
	});
});
